import { createBrowserHistory } from 'history';

/**
 * Переопределении и передача в контекст react-router
 * объекта history.
 *
 * См. https://reacttraining.com/react-router/core/api/Router
 */
export default createBrowserHistory({});
